var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var ReportSectionEnum;
(function (ReportSectionEnum) {
    ReportSectionEnum[ReportSectionEnum["TIMELINE_REPORT"] = 1] = "TIMELINE_REPORT";
    ReportSectionEnum[ReportSectionEnum["KPI_REPORT"] = 2] = "KPI_REPORT";
    ReportSectionEnum[ReportSectionEnum["LOCAL_AREAS_REPORT"] = 3] = "LOCAL_AREAS_REPORT";
    ReportSectionEnum[ReportSectionEnum["MENTION_TIMELINE_REPORT"] = 4] = "MENTION_TIMELINE_REPORT";
    ReportSectionEnum[ReportSectionEnum["EXPOSURE_KPI_REPORT"] = 5] = "EXPOSURE_KPI_REPORT";
    ReportSectionEnum[ReportSectionEnum["EXPOSURE_PLATFORM_REPORT"] = 6] = "EXPOSURE_PLATFORM_REPORT";
    ReportSectionEnum[ReportSectionEnum["BEST_EXPOSURE_REPORT"] = 7] = "BEST_EXPOSURE_REPORT";
    ReportSectionEnum[ReportSectionEnum["SEGMENTATION_INFLUENCER_OVERVIEW_REPORT"] = 8] = "SEGMENTATION_INFLUENCER_OVERVIEW_REPORT";
    ReportSectionEnum[ReportSectionEnum["SEGMENTATION_SEGMENT_REPORT"] = 9] = "SEGMENTATION_SEGMENT_REPORT";
    ReportSectionEnum[ReportSectionEnum["SEGMENTATION_INDUSTRY_REPORT"] = 10] = "SEGMENTATION_INDUSTRY_REPORT";
    ReportSectionEnum[ReportSectionEnum["INSIGHT_OPPORTUNITY_REPORT"] = 11] = "INSIGHT_OPPORTUNITY_REPORT";
    ReportSectionEnum[ReportSectionEnum["INSIGHT_BENCHMARK_REPORT"] = 12] = "INSIGHT_BENCHMARK_REPORT";
    ReportSectionEnum[ReportSectionEnum["BEST_PERFORMING_INFLUENCER_REPORT"] = 16] = "BEST_PERFORMING_INFLUENCER_REPORT";
    ReportSectionEnum[ReportSectionEnum["ROI_REPORT"] = 17] = "ROI_REPORT";
    ReportSectionEnum[ReportSectionEnum["INTERACTION_REPORT"] = 18] = "INTERACTION_REPORT";
    ReportSectionEnum[ReportSectionEnum["OONA_REPORT"] = 19] = "OONA_REPORT";
})(ReportSectionEnum || (ReportSectionEnum = {}));
var Report = /** @class */ (function () {
    function Report() {
        this.sectionList = [];
    }
    return Report;
}());
export { Report };
var ReportSection = /** @class */ (function () {
    function ReportSection() {
    }
    return ReportSection;
}());
export { ReportSection };
var ReportCreation = /** @class */ (function () {
    function ReportCreation() {
        this.sections = [];
    }
    return ReportCreation;
}());
export { ReportCreation };
var BenchmarkPerformanceReportDataPostItem = /** @class */ (function () {
    function BenchmarkPerformanceReportDataPostItem() {
    }
    return BenchmarkPerformanceReportDataPostItem;
}());
export { BenchmarkPerformanceReportDataPostItem };
var BenchmarkPerformanceReportData = /** @class */ (function () {
    function BenchmarkPerformanceReportData() {
    }
    return BenchmarkPerformanceReportData;
}());
export { BenchmarkPerformanceReportData };
var SegmentInfluencer = /** @class */ (function () {
    function SegmentInfluencer() {
    }
    return SegmentInfluencer;
}());
export { SegmentInfluencer };
var SegmentLineChartData = /** @class */ (function () {
    function SegmentLineChartData() {
    }
    return SegmentLineChartData;
}());
export { SegmentLineChartData };
var SegmentCircleChartData = /** @class */ (function (_super) {
    __extends(SegmentCircleChartData, _super);
    function SegmentCircleChartData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SegmentCircleChartData;
}(SegmentLineChartData));
export { SegmentCircleChartData };
var SegmentInfluencerSummarize = /** @class */ (function (_super) {
    __extends(SegmentInfluencerSummarize, _super);
    function SegmentInfluencerSummarize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SegmentInfluencerSummarize;
}(SegmentCircleChartData));
export { SegmentInfluencerSummarize };
var InteractionReportItem = /** @class */ (function () {
    function InteractionReportItem() {
    }
    return InteractionReportItem;
}());
export { InteractionReportItem };
var InteractionReportData = /** @class */ (function () {
    function InteractionReportData() {
    }
    return InteractionReportData;
}());
export { InteractionReportData };
var BestPerformingInfluencer = /** @class */ (function () {
    function BestPerformingInfluencer() {
    }
    return BestPerformingInfluencer;
}());
export { BestPerformingInfluencer };
var ChannelOpportunityItem = /** @class */ (function () {
    function ChannelOpportunityItem() {
    }
    return ChannelOpportunityItem;
}());
export { ChannelOpportunityItem };
var KpiReport = /** @class */ (function () {
    function KpiReport(kpi) {
        this.name = kpi.name;
        this.percent = kpi.percent;
        this.status = kpi.status;
        this.value = kpi.value;
    }
    return KpiReport;
}());
export { KpiReport };
/**
 * model for Segment Industries Report
 */
var SegmentIndustry = /** @class */ (function () {
    function SegmentIndustry() {
    }
    return SegmentIndustry;
}());
export { SegmentIndustry };
var IndustryBarChart = /** @class */ (function () {
    function IndustryBarChart() {
    }
    return IndustryBarChart;
}());
export { IndustryBarChart };
var IndustryPieChart = /** @class */ (function (_super) {
    __extends(IndustryPieChart, _super);
    function IndustryPieChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IndustryPieChart;
}(IndustryBarChart));
export { IndustryPieChart };



// WEBPACK FOOTER //
// ./src/models/measure/report.ts.pre-build-optimizer.js